// Overlay > Overlay
import React from 'react'
import { OverlayProps, OverlayState, defaultProps } from './IOverlay'
import styles from './Overlay.module.css'
import FlexBox from '../FlexBox'
import BlockTypeSelector from '../BlockTypeSelector'
import { IBlockType } from '../BlockType'
import { BlockTypeSelectState } from '../UxGrid'

const preventBubble = (event: React.MouseEvent<HTMLDivElement>) => {
	event.preventDefault()
}

class Overlay<BlockTypesType> extends React.PureComponent<OverlayProps<BlockTypesType>, OverlayState> {
	static readonly defaultProps = defaultProps

	constructor(props: OverlayProps<BlockTypesType>) {
		super(props)
		const { block } = props
		const { indexes, types } = block

		this.state = {
			start: indexes[0],
			end: indexes[indexes.length - 1] + 1,
			selected: types.map(type => this.props.blockTypes.indexOf(type).toString())
		}
	}

	/**
	 * switches the selected block type
	 */
	private _onBlockTypeSelect = (ix: string) => {
		const { selected } = this.state
		const stateUpdate: BlockTypeSelectState = {
			selected
		}

		if (this.props.multiTypeSelect) {
			const selectedIx = selected.indexOf(ix)

			const copy = selected.splice(0)
			// remove the ix from the selected list
			if (selectedIx > -1 && copy.length > 0) {
				copy.splice(selectedIx, 1)
			} else {
				// add the ix to the list
				copy.push(ix)
			}

			stateUpdate.selected = copy
		} else {
			stateUpdate.selected = [ix]
		}

		this.setState(stateUpdate as any)
	}

	render() {
		const { selected } = this.state
		const { blockTypes, handleClose, Content, multiTypeSelect, ...rest } = this.props
		const selectedTypes = blockTypes.reduce((acc: IBlockType<BlockTypesType>[], cur, ix) => {
			if (selected.includes(ix.toString())) {
				acc.push(cur)
			}

			return acc
		}, [])

		return (
			<div className={styles.root} onClick={preventBubble}>
				<FlexBox container className={styles.controls}>
					<button onClick={handleClose}>X</button>
				</FlexBox>
				<FlexBox container>
					<FlexBox container direction="column">
						<Content selectedBlockTypes={selectedTypes} handleClose={handleClose} {...rest} />
						{/* <div>
							<h4>{block.label}</h4>
							<p>{`${labelConversion(start)} - ${labelConversion(end)}`}</p>
						</div>
						{children} */}
					</FlexBox>
					{blockTypes.length > 1 && (
						<BlockTypeSelector
							multiSelect={multiTypeSelect}
							selected={selected}
							blockTypes={blockTypes}
							onSelect={this._onBlockTypeSelect}
						/>
					)}
				</FlexBox>
			</div>
		)
	}
}

export default Overlay
